import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { signal } from '@angular/core';
import { environment } from '@/environments/environment';

export interface FeatureFlags {
  enableCredentialsLogin: boolean;
}

const DEFAULT_FLAGS: FeatureFlags = {
  enableCredentialsLogin: false,
};

@Injectable({
  providedIn: 'root',
})
export class FeatureFlagsService {
  private http = inject(HttpClient);
  private _flags = signal<FeatureFlags>(DEFAULT_FLAGS);
  readonly flags = this._flags.asReadonly();

  load(): void {
    this.http
      .get<FeatureFlags>(environment.featureFlagsUrl, {
        headers: { 'Cache-Control': 'no-cache' },
      })
      .subscribe({
        next: (flags) => this._flags.set({ ...DEFAULT_FLAGS, ...flags }),
        error: () => this._flags.set(DEFAULT_FLAGS),
      });
  }
}
